import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { getPartnerMe, partnerLogout } from "../api/partnerAuthApi";

const PartnerAuthContext = createContext(null);

export function PartnerAuthProvider({ children }) {
  const [partner, setPartner] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const body = await getPartnerMe();
      setPartner(body.partner || null);
    } catch {
      setPartner(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const logout = useCallback(async () => {
    await partnerLogout().catch(() => {});
    setPartner(null);
  }, []);

  const value = useMemo(
    () => ({
      partner,
      loading,
      isAuthenticated: Boolean(partner?.partnerUserId),
      refresh,
      logout,
    }),
    [partner, loading, refresh, logout]
  );

  return (
    <PartnerAuthContext.Provider value={value}>{children}</PartnerAuthContext.Provider>
  );
}

export function usePartnerAuth() {
  const ctx = useContext(PartnerAuthContext);
  if (!ctx) {
    throw new Error("usePartnerAuth must be used within PartnerAuthProvider");
  }
  return ctx;
}
